<template>
  <div style="min-height: calc(100vh - 158px);" class="card">

    <div class="card p-2" style="min-height: 200px">
      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th>#</th>
            <th>Date & Time</th>
            <th>Previous Stage</th>
            <th>Updated Stage</th>
            <th>Updated By</th>
            <th>Notes</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in activityLogs" :key="i">
            <td>{{ ++i }}</td>
            <td>{{ item.start_time }}</td>
            <td>{{ item.previous_stage_name }}</td>
            <td>{{ item.beneficiary_stage_name }}</td>
            <td>{{ item.updated_by }}</td>
            <td v-html="item.full_description"></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mb-2"></div>
    <Loader v-if="loading"/>
  </div>

</template>

<script setup>

import {inject, onMounted, ref, watch} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import TitleButton from "@/components/atom/TitleButton.vue";
import handleProjects from "@/services/modules/procurement/project";
import {useRoute, useRouter} from "vue-router";

const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { getBeneficiaryStageData } = handleProjects();
const loading = ref(false)
const isEdit = ref(false)
const activityLogs = ref([])
function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const fetchActivityLogsData = () => {
  let query = getQuery();
  query += "&type=beneficiary_stage";
  query += "&contact_profile_id=" + route.query.contactId;
  activityLogs.value = [];
  getBeneficiaryStageData(query).then((res) => {
    if (!res.status) {
      return;
    }
    activityLogs.value = res.data;
  })
}

watch(() => route.query.contactId, (newValue) => {
  fetchActivityLogsData()
})
onMounted(() => {
  fetchActivityLogsData()
})

</script>

<style scoped>

</style>
